import { checkinApi } from '@/services/api/httpClient';
import { receiveResponseOfPaymentAdapter } from '@/utils/adapters/payment.adapter';

const admissionPaymentActions = {
  async getPaymentByAdmissionId({ commit, state }, payload = {}) {
    const admissionId = state.data.id;
    const url = `/payment/${admissionId}`;
    try {
      const getAdmissionPayment = await checkinApi().get(url, { payload });

      if (getAdmissionPayment.data) {
        const payment = receiveResponseOfPaymentAdapter(getAdmissionPayment.data);
        commit('SET_ADMISSION_PAYMENT', payment);
      }

      return getAdmissionPayment.data;
    } catch (error) {
      return null;
    }
  },

  async createAdmissionPaymentCommand({ commit, getters }, payload = {}) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/payment/create/${admissionId}`;
    try {
      const admissionCreatePayment = await checkinApi().post(url, { payload });

      const payment = receiveResponseOfPaymentAdapter(admissionCreatePayment.data);

      await commit('SET_ADMISSION_PAYMENT', payment);

      return true;
    } catch (error) {
      return false;
    }
  },

  async updateAdmissionPaymentPrivate({ commit, getters }, payload = {}) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/payment/update/private/${admissionId}`;
    try {
      const admissionPaymentUpdated = await checkinApi().patch(url, { payload });

      const payment = receiveResponseOfPaymentAdapter(admissionPaymentUpdated.data);

      await commit('SET_ADMISSION_PAYMENT', payment);
      return true;
    } catch (error) {
      return false;
    }
  },

  async updateAdmissionPaymentHealthInsurance({ commit, getters }, payload = {}) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/payment/update/health-insurance/${admissionId}`;
    try {
      const admissionPaymentUpdated = await checkinApi().patch(url, payload);

      const payment = receiveResponseOfPaymentAdapter(admissionPaymentUpdated.data.payment);

      await commit('SET_ADMISSION_PAYMENT', payment);
      return true;
    } catch (error) {
      return false;
    }
  },

  async updateAdmissionPaymentSwitchType({ commit, getters }, payload = {}) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/payment/switch/${admissionId}`;
    try {
      const admissionPaymentUpdated = await checkinApi().patch(url, payload);

      const payment = receiveResponseOfPaymentAdapter(admissionPaymentUpdated.data);

      await commit('SET_ADMISSION_PAYMENT', payment);
      return true;
    } catch (error) {
      return false;
    }
  },

  async authorizeAdmissionHealthInsuranceTransaction(
    { commit, getters },
    { transactionId, payload },
  ) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/payment/authorize/${admissionId}/transaction/${transactionId}`;
    try {
      const admissionPaymentUpdated = await checkinApi().patch(url, payload);
      const payment = receiveResponseOfPaymentAdapter(admissionPaymentUpdated?.data?.payment);
      await commit('SET_ADMISSION_PAYMENT', payment);
      return payment?.status === 'AUTHORIZED';
    } catch (error) {
      return false;
    }
  },
};

export default admissionPaymentActions;
